<ng-template #modalContent>
  <h2>{{ i18n.langString("sensor_instruction_title") }}</h2>

  @let instructions = sensorInstructionData();
  @if (instructions && instructions.length > 0) {
    @for (item of instructions; track item) {
      <app-overlay-card-item [item]="item"></app-overlay-card-item>
    }
  } @else {
    No items to display
  }

  <div class="buttonwrapper">
    <app-nav-button [primary]="true" (clickEvent)="cancelClick()">
      {{ i18n.langString("got_it") }}
    </app-nav-button>
  </div>
</ng-template>

<nz-modal
  [nzVisible]="modalOpen()"
  [nzCentered]="true"
  [nzFooter]="null"
  [nzContent]="modalContent"
  nzTitle="Sensor instructions"
  [nzCloseIcon]="'icons:exit'"
  (nzOnCancel)="cancelClick()"
>
  <div class="buttonwrapper">
    <app-nav-button [primary]="true" (clickEvent)="closeButton.emit()">{{
      i18n.langString("got_it")
    }}</app-nav-button>
  </div>
</nz-modal>
